import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Context } from '../Store/context'
import { GetPages } from '../api/Queries/get'
import Loading from './loader/loader';

const UsefulSite = () => {
    const [pages, setPages] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const { t, i18n } = useTranslation();
    const { showError } = useContext(Context);

    useEffect(() => {
        setIsLoading(true)
        const getCodex = async () => {
            try {
                const data = await GetPages()
                setIsLoading(false)
                setPages(data)
            } catch (error) {
                showError(error.message);
                setIsLoading(false)
            }
        }
        getCodex()
    }, [showError])

    const getLawName = (laws) => {
        const currentLang = i18n.language;
        if (currentLang === 'ru') {
            return laws.rus_name;
        } else if (currentLang === 'en') {
            return laws.eng_name;
        }
        return laws.tm_name;
    };

    return (
        <div className="bg-white rounded-md dark:bg-dark-box
                        dark:text-dark-text px-4 py-3 text-sm 
                        h-[600px] xl:h-[900px] mt-4">
            <h2 className='font-bold text-lg mb-2'>{t('useful_sites')}</h2>
            <ul className="space-y-4  max-h-full overflow-y-scroll">
                {isLoading ? <Loading /> : <>
                    {pages?.map((d) => (
                        <Link to={d.link_to_page} key={d.id}>
                            <li className='flex items-center py-2 gap-3'>
                                <span className='bg-secondary w-[20%] text-primary p-1 
                                             flex justify-center items-center
                                             rounded-md'>
                                    <img
                                        src={d.photo}
                                        alt="undefined"
                                        className='h-12 w-12 object-contain'
                                    />
                                </span>
                                <p className='w-[80%]'>{getLawName(d)}</p>
                            </li>
                        </Link>
                    ))}
                </>}
            </ul>
        </div>
    )
}

export default UsefulSite;
